import React from 'react';

const PageAlgemeneVoorwaarden: React.FC = () => {

  return (
    <>
      <header className="page-header container">
        <h1>Algemene gebruiksvoorwaarden</h1>
       
      </header>

      <section>
        <div className="container">
          <div className="row">
            <div className="col-12">
             
              <h4>Definities</h4>
              <div className="form">
                <div className="table-responsive table-responsive-1024">
                    <table role="table">
                        {/* <thead>
                            <tr role="row" className="mat-header-row cdk-header-row">
                                <th role="columnheader">
                                  Definities
                                </th>
                                <th role="columnheader">
                                  Omschrijving
                                </th>
                            </tr>
                        </thead> */}
                        <tbody>
                            <tr role="row">
                                <td role="cell">
                                  Deelnemer(s):
                                </td>
                                <td role="cell">
                                  Deelnemers aan de Stichting Mijn Aansluiting (netbeheerders ondergrondse infrastructuur) die gebruik maken van de Dienst.
                                </td>
                            </tr>
                            <tr role="row">
                                <td role="cell">
                                  Dienst:
                                </td>
                                <td role="cell">
                                  infraplannen.nl inclusief de daartoe behorende technische koppelingen.
                                </td>
                            </tr>
                            <tr role="row">
                                <td role="cell">
                                  Gebruiker: 
                                </td>
                                <td role="cell">
                                  Medewerker van een van de Deelnemer(s) of Deelnemende Organisatie(s) die gebruikt maakt van de Dienst.
                                </td>
                            </tr>
                            <tr role="row">
                                <td role="cell" data-label="Complexiteit:" >
                                  Mijn Aansluiting: 
                                </td>
                                <td role="cell" data-label="Termijn:" >
                                  Stichting Mijn Aansluiting ingeschreven in het Handelsregister bij de KvK onder nummer 58725938, beheerder van de Dienst.
                                </td>
                            </tr>
                            <tr role="row">
                                <td role="cell">
                                  Deelnemende Organisatie(s): 
                                </td>
                                <td role="cell">
                                  Deelnemende organisaties, niet zijnde Deelnemers, die gebruik maken van de Dienst.
                                </td>
                            </tr>
                            <tr role="row">
                                <td role="cell">
                                  Gebruiksvoorwaarden:
                                </td>
                                <td role="cell">
                                  Deze algemene gebruiksvoorwaarden.
                                </td>
                            </tr>
                        </tbody>
                        {/* <tfoot role="rowgroup" className="mat-table-sticky">
                            <i className="note">Nog een notitie</i>
                        </tfoot> */}
                    </table>
                </div>
              </div>

              <ol className="list-with-counter">
                <li>
                  <h4>Artikel 1 - Toepassingsbereik en doel</h4>
                  <ol>
                    <li>Deze Gebruiksvoorwaarden zijn van toepassing op een iedere Deelnemer en Deelnemende Organisatie die gebruik maakt van de Dienst.</li>
                    <li>De Dienst biedt Deelnemers de mogelijkheid om plannen (m.b.t. de ondergrondse infrastructuur) onderling en met Deelnemende Organisaties te delen en in te zien. Daarmee draagt de Dienst bij aan het realiseren van een voorspelbare en continue werkstroom in de keten. Naast inzicht in elkaars plannen, gaat de Dienst de Deelnemers en Deelnemende Organisaties faciliteren om plannen op elkaar af te stemmen, wat publieke overlast beperkt en efficiëntie verhoogt.</li>
                  </ol>
                </li>

                <li>
                  <h4>Artikel 2 - Intellectuele eigendomsrechten</h4>
                  <ol>
                    <li>Deelnemers en Deelnemende Organisaties gaan via de Dienst data / informatie, met uitzondering van persoonsgegevens, met elkaar delen. De intellectuele-/eigendomsrechten op de informatie berust bij de Deelnemer of Deelnemende Organisatie die de informatie op de Dienst heeft geplaatst. Het is zonder voorafgaande schriftelijke toestemming van de eigenaar van de informatie onder meer verboden om:
                      <ul>
                        <li>(een kopie van) een gedeelte van de informatie te gebruiken voor commerciële doeleinden;</li>
                        <li>(een gedeelte van) de informatie te wijzigen of op te nemen in enig ander werk.</li>
                      </ul>
                    </li>
                  </ol>
                </li>

                <li>
                  <h4>Artikel 3 - Gebruik</h4>
                  <ol>
                    <li>Gebruikers worden verwacht redelijke instructies van Mijn Aansluiting ten aanzien van het gebruik van deze Dienst op te volgen. Wanneer (een medewerker van) Mijn Aansluiting acties constateert die tegen de Gebruiksvoorwaarden of algemene gedragsnormen ingaan, heeft Mijn Aansluiting de mogelijkheid om de toegang tot de Dienst tijdelijk dan wel blijvend te blokkeren.</li>
                    <li>De Gebruiker is zelf aansprakelijk voor de gevolgen van elk (on)bevoegd gebruik van de aan hem verstrekte toegangsgegevens door derden.</li>
                    <li>Het is Gebruikers niet toegestaan informatie te plaatsen, dan wel een activiteit uit te voeren die:
                      <ul>
                        <li>virussen bevat of anderszins de software en/of hardware kan beschadigen van Mijn Aansluiting of van andere Gebruikers;</li>
                        <li>onwettig is, zoals het plaatsen en delen van informatie waarvoor geen uitdrukkelijke toestemming is gegeven door betreffende eigenaar. Dit is onrechtmatig en doet inbreuk op iemands privacy- en/of eigendomsrecht;</li>
                        <li>een onredelijk of buitengewoon groot beslag legt op enige infrastructuur van de Dienst.</li>
                      </ul>
                    </li>
                    <li>Daarnaast is het Gebruikers niet toegestaan de software en/of overige door Mijn Aansluiting aangeboden voorzieningen te gebruiken om onbevoegd toegang te zoeken dan wel te verkrijgen tot netwerken of computersystemen van Mijn Aansluiting of van derden, verkregen informatie onrechtmatig te gebruiken, gegevensbestanden en/of programmatuur te beschadigen of onrechtmatig te gebruiken.</li>
                    <li>Mijn Aansluiting garandeert niet dat deze Dienst foutloos of ononderbroken zal functioneren.</li>
                  </ol>
                </li>

                <li>
                  <h4>Artikel 4 - Inhoud</h4>
                  <ol>
                    <li>De inhoud van deze Dienst is met de grootst mogelijke zorg samengesteld. Alle specifieke informatie met betrekking tot plannen wordt aangeleverd door de Deelnemers en Deelnemende Organisaties die deze plannen delen. Mijn Aansluiting is niet verantwoordelijk voor deze informatie en kan daarom niet garanderen dat de inhoud van deze Dienst en/of de inhoud van de plannen te allen tijde juist, actueel en volledig is.</li>
                    <li>Als er wordt verwezen naar een plan, kunt u voor informatie over dit plan terecht bij de Deelnemer of Deelnemende Organisatie die het plan aanbiedt.</li>
                  </ol>
                </li>

                <li>
                  <h4>Artikel 5 - Geheimhouding</h4>
                  <ol>
                    <li>Via de Dienst worden plannen en planinformatie met elkaar gedeeld op basis van vertrouwelijkheid. Plannen worden niet openbaar gedeeld, maar toegang tot de plannen wordt expliciet tussen Deelnemers en/of met Deelnemende Organisaties afgestemd. Hiertoe worden onderling afspraken gemaakt met betrekking tot geheimhouding.</li>
                    <li>Bij het gebruiken van de Dienst voor het verkrijgen en lezen van plannen conformeren de Deelnemers en Deelnemende Organisaties zich in aanvulling op de eventueel rechtstreeks gemaakte afspraken in ieder geval ook aan onderstaande afspraken met betrekking tot geheimhouding:
                      <ul>
                        <li>De plannen mogen alleen gebruikt worden voor het doel waarvoor het verstrekt is;</li>
                        <li>De plannen mogen zonder expliciete toestemming van de eigenaar niet verder extern gedeeld worden;</li>
                        <li>De Gebruiker draagt zorg voor correct gebruik en bescherming van de plannen;</li>
                        <li>De Gebruiker meldt een security incident en/of datalek bij de eigenaar van de plannen indien de plannen mogelijkerwijs door een niet-geautoriseerde gebruiker zijn ingezien.</li>
                      </ul>
                    </li>
                  </ol>
                </li>

                <li>
                  <h4>Artikel 6 - Schade (aansprakelijkheid)</h4>
                  <ol>
                    <li>Mijn Aansluiting aanvaardt op geen enkele wijze aansprakelijkheid voor directe of indirecte schade, incidentele of gevolgschade, boetes of immateriële schade die op enigerlei wijze met betrekking tot deze Dienst ontstaat. Zo is Mijn Aansluiting niet aansprakelijk voor:
                      <ul>
                        <li>defecten, virussen en andere onvolkomenheden ten gevolge van apparatuur en andere software in verband met de toegang tot of het gebruik van de Dienst;</li>
                        <li>de informatie die op of via de Dienst ter beschikking wordt gesteld;</li>
                        <li>het al dan niet functioneren van de Dienst;</li>
                        <li>misbruik van de Dienst;</li>
                        <li>het verlies of wijzigen van gegevens;</li>
                        <li>aanspraken van derden in verband met gebruik van deze Dienst.</li>
                      </ul>
                    </li>
                    <li>Bovenstaande uitsluiting van aansprakelijkheid is niet van toepassing in geval van opzet of grove nalatigheid van Mijn Aansluiting.</li>
                  </ol>
                </li>

                <li>
                  <h4>Artikel 7 - Externe websites</h4>
                  <ol>
                    <li>De Dienst kan verwijzingen bevatten naar andere websites (bijvoorbeeld door middel van een hyperlink, banner of button). Dit betekent niet dat de Dienst verbonden is aan deze websites of de eigenaren ervan. Mijn Aansluiting aanvaardt geen verantwoordelijkheid of aansprakelijkheid met betrekking tot de inhoud, het gebruik of de beschikbaarheid van dergelijke websites, of de daarin opgenomen informatie.</li>
                  </ol>
                </li>

                <li>
                  <h4>Artikel 8 - Privacy en cookies</h4>
                  <ol>
                    <li>De wijze waarop Mijn Aansluiting omgaat met persoonsgegevens van de Deelnemers en Deelnemende Organisaties staat in de privacyverklaring.</li>
                    <li>Om ervoor te zorgen dat de Dienst goed werkt, maakt de Dienst gebruik van cookies. Welke cookies dit zijn en wat zij doen, staat ook in de privacyverklaring.</li>
                  </ol>
                </li>

                <li>
                  <h4>Artikel 9 - Contact</h4>
                  <ol>
                    <li>Voor vragen over deze dienst kan contact worden opgenomen met de beheerders via <a href="mailto:contact@infraplannen.nl">contact@infraplannen.nl</a>.</li>
                  </ol>
                </li>

                <li>
                  <h4>Artikel 10 - Toepasselijk recht</h4>
                  <ol>
                    <li>Op deze Dienst en Gebruiksvoorwaarden is Nederlands recht van toepassing.</li>
                    <li>Alle eventuele geschillen tussen een Deelnemer en/of Deelnemende Organisatie en Mijn Aansluiting die hieruit voortvloeien of anderszins verband houden met deze Dienst of de daarop gepubliceerde informatie worden voorgelegd aan de daartoe bevoegde rechter van de rechtbank in Utrecht.</li>
                  </ol>
                </li>

                <li>
                  <h4>Artikel 11 - Wijzigingen</h4>
                  <ol>
                    <li>Mijn Aansluiting is bevoegd om, zonder voorafgaande kennisgeving op elk moment wijzigingen en correcties in deze Dienst en/of deze Gebruiksvoorwaarden aan te brengen.</li>
                  </ol>
                </li>
              </ol>

              <em>Deze gebruiksvoorwaarden zijn voor het laatst gewijzigd op 2 april 2025.</em>


            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PageAlgemeneVoorwaarden;